import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const ImageSliderPopup = ({ imgData, setImgData, imgs }) => {
    const sliderRef = useRef(null);

    useEffect(() => {
        if (sliderRef.current && imgData.see) {
            sliderRef.current?.slideTo(imgData.imgIndex);
        }
    }, [imgData.see, imgData.imgIndex]);

    return (
        <>
            <div className={`fixed top-0 left-0 ${imgData.see ? ' bg-[#0000008a] bg-opacity-40 backdrop-blur w-full h-dvh z-30 opacity-100' : 'opacity-0 z-0 h-0 w-0'} transition-all duration-150 ease-in-out px-20 py-[1rem] max-lg:px-8`}>
                <div className="flex justify-end w-full">
                    <div className="mx-2 bg-primary-tw size-9 rounded-full flex justify-center items-center cursor-pointer" title="Close"
                        onClick={() => setImgData(prev => ({ ...prev, see: !prev.see }))}>
                        <X size={20} color="white" />
                    </div>
                </div>
            </div>
            {
                imgData.see &&
                <main className="flex justify-between items-center px-4 w-full gap-7 fixed top-10 right-0 z-[8000] max-lg:top-20">
                    <button className="p-1 z-50 prev-img bg-secondary-tw rounded-md">
                        <ChevronRight size={20} color="white" />
                    </button>
                    <Swiper
                        modules={[Navigation]}
                        navigation={{
                            nextEl: '.next-img',
                            prevEl: '.prev-img'
                        }}
                        ref={sliderRef}
                        onSwiper={(swiper) => {
                            sliderRef.current = swiper;
                            swiper.slideTo(imgData.imgIndex);
                        }}
                    >
                        {imgs.map((img, i) => (
                            <SwiperSlide key={i}>
                                <div className="w-6/12 h-[96dvh] max-lg:w-full max-lg:h-full">
                                    <img
                                        src={img?.image}
                                        alt={`img-${i}`}
                                        className="w-full h-full object-cover"
                                        style={{}}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button className="p-1 z-50 next-img bg-secondary-tw rounded-md">
                        <ChevronLeft size={20} color="white" />
                    </button>
                </main>
            }
        </>
    );
};

export default ImageSliderPopup;
